import { PushPinIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Pin = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <PushPinIcon size={Sizes[size]} {...rest} color={fill} />;
};

Pin.displayName = 'Pin';
